// src/components/ui/button.jsx
import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-zinc-950 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98] select-none",
    {
        variants: {
            variant: {
                default:
                    "bg-brand-gradient text-white shadow-soft hover:shadow-card-hover hover:brightness-[1.07]",
                solid:
                    "bg-zinc-900 text-white hover:bg-zinc-800 dark:bg-zinc-100 dark:text-zinc-900 dark:hover:bg-white",
                outline:
                    "border border-zinc-200 bg-white/60 text-zinc-900 hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 dark:border-zinc-800 dark:bg-zinc-900/40 dark:text-zinc-100 dark:hover:border-brand-700 dark:hover:bg-brand-950/40 dark:hover:text-brand-200",
                ghost:
                    "bg-transparent text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-800/60 dark:hover:text-zinc-50",
                destructive:
                    "bg-red-600 text-white shadow-soft hover:bg-red-700",
                subtle:
                    "bg-brand-50 text-brand-700 hover:bg-brand-100 dark:bg-brand-950/50 dark:text-brand-200 dark:hover:bg-brand-900/50",
            },
            size: {
                sm: "h-9 px-3.5",
                md: "h-10 px-4",
                lg: "h-12 px-7 text-[15px]",
                icon: "h-10 w-10",
                "icon-sm": "h-9 w-9",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "md",
        },
    }
);

export function Button({ className, variant, size, ...props }) {
    return (
        <button className={cn(buttonVariants({ variant, size }), className)} {...props} />
    );
}

export { buttonVariants };
